import React from 'react';
import { useSelector } from 'react-redux';

const Header = () => {
  const { totalCount } = useSelector((state) => state.adminPanelAgencyDoctors);
  return (
    <div className="adminPanel__header">
      <h5>
        Agency Users List: <strong>{totalCount}</strong>
      </h5>
    </div>
  );
};

export default Header;
